import { FaInfoCircle } from 'react-icons/fa';

export default function LegacyViewBadge() {
  return (
    <div
      className="absolute top-3 right-3 z-[1000] flex items-center gap-1 bg-amber-50 text-amber-800 border border-amber-200 text-xs px-2 py-1 rounded shadow"
      title="Showing standard satellite imagery — detailed yard layout not available for this facility."
    >
      <FaInfoCircle />
      Legacy view
    </div>
  );
}
